<template>
    <page-view title="专家费用列表">
        <template slot="action">
        </template>
        <a-card>
            <a-form-model :model="form" ref="form">
                <a-row>
                    <a-col :span="5">
                        <a-form-model-item label="专家姓名" prop="projectName">
                            <a-input v-model="form.name"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="7" :offset="1">
                        <a-form-model-item label="专业类别" prop="groups">
                            <dict-cascader dictKey="expert_profession" v-model="form.groups" style="width: 100%"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-item label="专家出行日期">
                            <a-date-picker format="YYYY-MM-DD" v-model="form.startDate" placeholder="开始日期"/>
                            <span style="width: 6%;display: inline-block;text-align: center">至</span>
                            <a-date-picker format="YYYY-MM-DD" v-model="form.endDate" placeholder="结束日期"/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24" class="footer-button">
                        <a-form-item :wrapperCol="{ span: 23 }" style="text-align: center">
                            <a-button type="primary" @click="onSearch">查询</a-button>
                            <a-button @click="reset" style="margin-left: 20px">重置</a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <s-table ref="table" bordered
                    :columns="columns"
                    :data="loadData"
                    :customRow="customRow"
                    :rowKey="record => record.expertId"
                    :pagination="{ showTotal: (total) => `共 ${total} 条` }"
            >
                <template slot="operation" slot-scope="record">
                    <a-popconfirm v-if="record.sumNoFees > 0"
                                  placement="bottom"
                                  @visibleChange="handleVisibleChange"
                                  title="是否确认支付?"
                                  @confirm="onPay(record)"
                                  @cancel="ifOperation = false"
                    >
                        <a-button :loading="payLoading">支付
                        </a-button>
                    </a-popconfirm>
                    <a-popconfirm v-else
                                  placement="bottom"
                                  @visibleChange="handleVisibleChange"
                                  title="是否确认撤回?"
                                  @confirm="onRevocation(record)"
                                  @cancel="ifOperation = false"
                    >
                        已全部支付
                        <a-button :loading="payLoading">撤回
                        </a-button>
                    </a-popconfirm>
                </template>
            </s-table>
        </a-card>
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import qs from 'qs'
import moment from 'moment'
import DictCascader from '@/components/dict/DictCascader'
import { getSortSql } from '@/utils/table'

const columns = [
  {
    title: '专家名称',
    dataIndex: 'expertName',
    width: 200
  },
  {
    title: '拟申报组别',
    align: 'center',
    dataIndex: 'groupsName'
  },
  {
    title: '参加次数',
    dataIndex: 'useNumber',
    sorter: true
  },
  {
    title: '最高费用（元）',
    dataIndex: 'maxFees',
    sorter: true
  },
  {
    title: '最低费用（元）',
    dataIndex: 'minFees',
    sorter: true
  },
  {
    title: '平均费用（元）',
    dataIndex: 'avgFees',
    sorter: true
  },
  {
    title: '总计费用（元）',
    dataIndex: 'sumFees',
    sorter: true
  },
  {
    title: '总计未支付费用（元）',
    dataIndex: 'sumNoFees',
    sorter: true
  }
  // ,
  // {
  //   title: '操作',
  //   width: '8%',
  //   align: 'center',
  //   scopedSlots: { customRender: 'operation' }
  // }
]
export default {
  name: 'expertFeesIndex',
  components: {
    PageView,
    STable,
    DictCascader
  },
  data () {
    return {
      columns,
      user: this.$ls.get('user'),
      caseTypeId: this.$route.query.caseTypeId,
      ifOperation: false, // 当触发操作列 的 按钮时，不触发详情onView
      payLoading: false,
      form: {
        startDate: moment().startOf('month'),
        endDate: moment().startOf('month').add(1, 'months')
      },
      total: null,
      customRow: (record, index) => {
        return {
          on: {
            click: () => {
              // 当触发操作列 的 按钮时，不触发详情onView
              if (this.ifOperation) {
                return
              }
              let data = {}
              data.expertId = record.expertId
              data.startDate = this.form.startDate
              data.endDate = this.form.endDate
              this.dateFormat(data)

              // this.$router.push({
              //   path: '/selectExpertApply/expertFeesProjectList', query: data
              // })

              var routeIndex = this.$router.resolve({
                path: '/selectExpertApply/expertFeesProjectList',
                query: data
              })
              window.open(routeIndex.href, '_blank')
            }
          }
        }
      },
      sortMap: [
        { sortField: 'useNumber', sortFieldOrig: 'use_number', sortOrder: '' },
        { sortField: 'maxFees', sortFieldOrig: 'max_fees', sortOrder: '' },
        { sortField: 'minFees', sortFieldOrig: 'min_fees', sortOrder: '' },
        { sortField: 'avgFees', sortFieldOrig: 'avg_fees', sortOrder: '' },
        { sortField: 'sumFees', sortFieldOrig: 'sum_fees', sortOrder: '' },
        { sortField: 'sumNoFees', sortFieldOrig: 'sum_no_fees', sortOrder: '' }
      ],
      loadData: (parameter) => {
        const data = { ...this.form }
        data.sorting = getSortSql(parameter, this.sortMap)
        this.dateFormat(data)
        return this.$http.get('/api/1/expertmain/selectExpertFeedback/query_expertFees_list.json', {
          params: Object.assign(parameter, data)
        }).then(res => {
          if (res.page) {
            this.total = res.page.total
          }
          return res
        })
      }
    }
  },
  methods: {
    reset () {
      this.form = {
        startDate: moment().startOf('month'),
        endDate: moment().startOf('month').add(1, 'months')
      }
      this.refresh()
    },
    onSearch () {
      this.refresh()
    },
    refresh () {
      this.$refs.table.refresh()
    },
    handleVisibleChange (visible) {
      this.ifOperation = true
      if (!visible) {
        this.ifOperation = false
      }
    },
    // 支付
    onPay (record) {
      this.ifOperation = true
      this.payLoading = true
      this.updateFeesState(record, '1')
    },
    // 支付撤回
    onRevocation (record) {
      this.ifOperation = true
      this.payLoading = true
      this.updateFeesState(record, '0')
    },
    // 修改支付状态的 请求方法
    updateFeesState (record, feesState) {
      const that = this

      let data = {}
      data.feesState = feesState
      data.appointExpertId = record.expertId
      data.startDate = this.form.startDate
      data.endDate = this.form.endDate
      this.dateFormat(data)

      that.$http.post('/api/1/expertmain/selectExpertFeedback/update_feesState.json', qs.stringify(data)).then(
        res => {
          if (res.code !== 200) {
            return
          }
          that.$message.success('操作成功！')
          that.$refs.table.refresh()
        }
      ).finally(function () {
        that.ifOperation = false
        that.payLoading = false
      })
    },
    onView (id) {
      // this.$router.push({
      //   path: '/selectExpertApply/view?id=' + id
      // })
    },
    dateFormat (data) {
      if (data.startDate) {
        data.startDate = data.startDate.format('YYYY-MM-DD')
      }
      if (data.endDate) {
        data.endDate = data.endDate.format('YYYY-MM-DD')
      }
      if (data.endDate < data.startDate) {
        this.$message.error('结束日期不能小于开始日期')
      }
    }
  }
}
</script>

<style lang="less" scoped>
    .ant-calendar-picker {
        width: 47% !important;
    }
</style>
